import { atom } from "jotai";

export const isDisplayAnnouncementAtom = atom(true);
